import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Coordinates } from '../../../core/types/types';
import { Position } from '@turf/turf';

export interface EarthEngineAreaOfInterestPolygonCoordinatesState {
    value: Position[] | undefined;
}

const initialState: EarthEngineAreaOfInterestPolygonCoordinatesState = {
    value: undefined,
};

export const earthEngineAreaOfInterestPolygonCoordinatesSlice = createSlice({
    name: 'earthEngineAreaOfInterestPolygonCoordsSetter',
    initialState,
    reducers: {
        earthEngineAreaOfInterestPolygonCoords: (state, action: PayloadAction<Position[]>) => {
            state.value = action.payload;
        },
    },
});

export const { earthEngineAreaOfInterestPolygonCoords } = earthEngineAreaOfInterestPolygonCoordinatesSlice.actions;
export default earthEngineAreaOfInterestPolygonCoordinatesSlice.reducer;
